import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Layout from '@/views/layout/Layout'

export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: Layout,
      redirect: '/',
      name: 'zh',
      meta: {
        title: 'zyc',
      },
      children: [
        {
          path: '/',
          component: () => import('./views/Home'),
          name: 'home',
          meta: { title: 'ZhuChongYun' }
        },
        {
          path: 'zh',
          component: () => import('./views/Index'),
          name: 'IndexZh',
          meta: { title: 'ZhuChongYun' }
        },
        {
          path: 'en',
          component: () => import('./views/Index'),
          name: 'IndexEn',
          meta: { title: 'ZhuChongYun' }
        },
        {
          path: '/show/:id',
          component: () => import('./views/Index'),
          name: 'Show',
          meta: { title: '展示' }
        },
        {
          path: '/job',
          component: () => import('./views/Index'),
          name: 'Job',
          meta: { titleEn: 'Job', title: '工作招聘' }
        },
        {
          path: '/philosophy',
          component: () => import('./views/Index'),
          name: 'Philosophy',
          meta: { titleEn: 'Philosophy', title: '品牌哲学' }
        },
        {
          path: '/address',
          component: () => import('./views/Index'),
          name: 'Address',
          meta: { titleEn: 'Store Location', title: '店铺地址' }
        },
        {
          path: '/statement',
          component: () => import('./views/Index'),
          name: 'Statement',
          meta: { titleEn: 'Statement', title: '版权声明' }
        },
        {
          path: '/video',
          component: () => import('./views/Index'),
          name: 'Video',
          meta: { titleEn: 'Video', title: '视频' }
        },
      ]
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
})
